"use client";

import React, { useState } from "react";
import RichText from "@onclicks/sharedcomponents/RichText";

interface TabContentClientProps {
  title?: string | null;
  subtitle?: string | null;
  richText?: any;
  background_color?: string | null;
  tabs: {
    label: string;
    content: React.ReactNode;
  }[];
}

export const TabContentBlockClient: React.FC<TabContentClientProps> = (
  props,
) => {
  const { tabs, background_color, title, subtitle, richText } = props;

  const [activeIndex, setActiveIndex] = useState<number>(0);

  return (
    <div
      className="px-6 lg:px-16 lg:grid lg:grid-cols-2 lg:gap-x-5 py-8 lg:py-15"
      style={{ backgroundColor: background_color || "transparent" }}
    >
      <div className="lg:mr-15">
        {title && <h1 className="text-3xl font-bold">{title}</h1>}
        {subtitle && <h2 className="text-3xl font-bold mb-2">{subtitle}</h2>}
        {richText && (
          <RichText data={richText} enableGutter={false} enableProse={false} />
        )}
      </div>

      {/* Onglets */}
      <div>
        <div>
          {tabs?.map((tab, index) => (
            <button
              key={index}
              onClick={() => {
                setActiveIndex(index);
              }}
              className={`mb-2 bg-transparent pb-2 mr-8 mt-5 lg:mt-0 ${index === activeIndex ? "border-b-2 border-black" : ""}`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Affichage du contenu de l'onglet actif */}
        <div>{tabs?.[activeIndex]?.content}</div>
      </div>
    </div>
  );
};
